import { Svg, cn } from "@ac-expo/ui-components";
import { SvgName } from "@ac-expo/ui-components";

type SignupSelectProps = {
  desc: string;
  title: string;
  svgName: SvgName;
  selected: boolean;
  onClick: () => void;
  className?: string;
};

export function SignupSelect({
  desc,
  title,
  svgName,
  selected,
  onClick,
  className,
}: SignupSelectProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      }}
      className={cn(
        "relative flex select-none flex-col items-center rounded-2xl border p-5",
        {
          "bg-primary-blue": selected,
          "bg-white": !selected,
        },
        className
      )}
      onClick={onClick}
    >
      {selected ? (
        <Svg name="check" alt="check" className="absolute left-3 top-3" />
      ) : null}
      <Svg
        name={(svgName + (selected ? "_gray_25" : "_gray_400")) as SvgName}
        alt=""
        isColored
      />
      <p
        className={cn("text-center text-xl", {
          "text-gray-50": selected,
          "text-gray-600": !selected,
        })}
      >
        {desc}
      </p>
    </div>
  );
}

export default SignupSelect;
